import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.scss';


const Icon = (props) => {
  let { set, icon, className, ...otherProps } = props;

  className = classNames(
    "ov-icon",
    `ov-${set}-icon`,
    `ov-${set}-icon-${icon}`,
    className
  );

  return (
    <svg id={`#${set}-icon-${icon}`} className={className} {...otherProps}>
      <use xlinkHref={`#${set}-icon-${icon}`}/>
    </svg>
  );
}


Icon.propTypes = {
  set: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired
};


export { Icon };
